var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatTxt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10701_3154)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_10701_3154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 32H7.79976C5.14879 32 2.99976 29.851 2.99976 27.2V4.8C2.99976 2.14903 5.14879 0 7.79976 0H16.4708C17.7309 0 18.9406 0.495552 19.8385 1.37968L27.5675 8.98974C28.4838 9.89196 28.9998 11.1241 28.9998 12.4101V27.2C28.9998 29.851 26.8507 32 24.1998 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 31.4H7.79976C5.48016 31.4 3.59976 29.5196 3.59976 27.2V4.8C3.59976 2.4804 5.48016 0.6 7.79976 0.6H16.4708C17.5734 0.6 18.6318 1.03361 19.4175 1.80722L27.1465 9.41728C27.9483 10.2067 28.3998 11.2849 28.3998 12.4101V27.2C28.3998 29.5196 26.5194 31.4 24.1998 31.4Z",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 1V7.8C18 9.56731 19.4327 11 21.2 11H28",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_10701_3154)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_10701_3154",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H20.3434C22.0003 14 23.3434 15.3431 23.3434 17V25C23.3434 26.6569 22.0003 28 20.3434 28H3C1.34315 28 0 26.6569 0 25V17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H20.3434C22.0003 14 23.3434 15.3431 23.3434 17V25C23.3434 26.6569 22.0003 28 20.3434 28H3C1.34315 28 0 26.6569 0 25V17Z",
    fill: "#0579D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.8 17C-0.8 14.9013 0.901318 13.2 3 13.2H20.3434C22.4421 13.2 24.1434 14.9013 24.1434 17H22.5434C22.5434 15.785 21.5584 14.8 20.3434 14.8H3C1.78497 14.8 0.8 15.785 0.8 17H-0.8ZM23.3434 28H0H23.3434ZM3 28C0.901318 28 -0.8 26.2987 -0.8 24.2V17C-0.8 14.9013 0.901318 13.2 3 13.2V14.8C1.78497 14.8 0.8 15.785 0.8 17V25C0.8 26.6569 1.78497 28 3 28ZM20.3434 13.2C22.4421 13.2 24.1434 14.9013 24.1434 17V24.2C24.1434 26.2987 22.4421 28 20.3434 28C21.5584 28 22.5434 26.6569 22.5434 25V17C22.5434 15.785 21.5584 14.8 20.3434 14.8V13.2Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-4-inside-1_10701_3154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18.7719V17.8H8.10625V18.7719H6.12813V24.2H4.97812V18.7719H3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2354 17.8L11.6448 20.1438H11.6948L13.1104 17.8H14.4323L12.4604 21L14.4635 24.2H13.1198L11.6948 21.8719H11.6448L10.2198 24.2H8.88225L10.9041 21L8.90725 17.8H10.2354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2372 18.7719V17.8H20.3434V18.7719H18.3653V24.2H17.2153V18.7719H15.2372Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_10701_3154",
    x: 1.39976,
    y: -3.2,
    width: 29.2,
    height: 37.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10701_3154"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10701_3154",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_10701_3154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_10701_3154",
    x: 0,
    y: 14,
    width: 23.3435,
    height: 17.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10701_3154"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10701_3154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatTxt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FormatTxt.70b6ceebf6164c9043219f20446bdc50.svg";